<div class="middle-content full-view-page assignment-full-view-page" id="assignment-item-view-holder" aria-live="assertive">
    <div class="item-view has-aside-block">
        <div class="section-block main-block">
            <div class="media">
                <button *ngIf="fromLms && !student && asgmtView" id="back-btn" class="btn-link groovy-btn no-padding" (click)="asgmtView = false" type="button" [rlAria]="'general.back' | translate" [rlTabIndex]>
                    <i class="fa fa-chevron-left"></i>
                    {{'general.back' | translate}}
                </button>
                <rl-assignment-statistics *ngIf="!student && asgmt?.id && !asgmtView" [assignment]="asgmt" (viewAssignment)="asgmtView = true"></rl-assignment-statistics>
                <div class="embedded-content">
                    <div class="pdf-viewer-holder">
                        <rl-assignment-view class="pdfViewerDiv" *ngIf="asgmt?.id && asgmtView" [assignment]="asgmt"></rl-assignment-view>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>